import {
    NOTIF_GET_USERS_SUCCESS,
    NOTIF_GET_NONUSERS_SUCCESS,
    NOTIF_COMPANIES_SUCCESS,
    NOTIF_GET_USERS_FAIL,
    NOTIF_CLEAR_USERS,
    NOTIF_CLEAR_NONUSERS,
    NONUSER_JOIN,
    NONUSER_POP,
    NOTIF_TOGGLE_CHECKBOX_ON,
    NOTIF_TOGGLE_CHECKBOX_OFF,
    HIDE_CUSTOM_NOTIFICATION_POPUP,
    SHOW_CUSTOM_NOTIFICATION_POPUP,
} from '../constants/action-types';
import { NotificationType } from '../constants/notifications';

const initialState = {
    users: [],
    nonusers: [],
    companies: [],
    isCustomNotificationPopupVisible: false,
};

export default function notifications(state = initialState, action) {
    switch (action.type) {
        case NOTIF_GET_USERS_SUCCESS:
            return {
                ...state,
                users: action.payload,
            };
        case NOTIF_GET_NONUSERS_SUCCESS:
            return {
                ...state,
                nonusers: action.payload,
            };
        case NOTIF_CLEAR_USERS:
            return {
                ...state,
                users: [],
            };
        case NOTIF_CLEAR_NONUSERS:
            return {
                ...state,
                nonusers: [],
            };
        case NOTIF_COMPANIES_SUCCESS:
            return {
                ...state,
                companies: action.payload,
            };
        case NONUSER_JOIN: {
            let nonusers = [];
            if (state.nonusers.some(item => item.entity_id === action.payload.entity_id)) {
                nonusers = state.nonusers.map(a => (a.entity_id === action.payload.entity_id ? action.payload : a));
            } else {
                nonusers = [action.payload, ...state.nonusers];
            }
            return {
                ...state,
                nonusers,
            };
        }
        case NONUSER_POP: {
            const index = state.nonusers.findIndex(x => +x.entity_id === +action.id);

            if (index || index === 0) {
                return {
                    ...state,
                    nonusers: state.nonusers.toSpliced(index, 1),
                };
            }

            return {
                ...state,
            };
        }

        case NOTIF_TOGGLE_CHECKBOX_ON: {
            const isNonUser = action.userType === 'nonusers';
            const targetKey = isNonUser ? 'nonusers' : 'users';
            const entityKey = isNonUser ? 'entity_id' : 'user_id';
            const target = state[targetKey];

            const curEntity = target.find(item => item[entityKey] === action.params[entityKey]);
            const whitelistKey = action.params.type === NotificationType.EMAIL ? 'email_whitelist' : 'push_whitelist';
            const whitelist = curEntity[whitelistKey];
            curEntity[whitelistKey] = [...new Set([...whitelist, ...action.params.product_ids])];
            const newTarget = [...state[targetKey]];

            return {
                ...state,
                [targetKey]: newTarget,
            };
        }

        case NOTIF_TOGGLE_CHECKBOX_OFF: {
            const isNonUser = action.userType === 'nonusers';
            const targetKey = isNonUser ? 'nonusers' : 'users';
            const entityKey = isNonUser ? 'entity_id' : 'user_id';
            const target = state[targetKey];

            const curEntity = target.find(item => item[entityKey] === action.params[entityKey]);
            const whitelistKey = action.params.type === NotificationType.EMAIL ? 'email_whitelist' : 'push_whitelist';
            const whitelist = curEntity[whitelistKey];
            curEntity[whitelistKey] = whitelist.filter(id => !action.params.product_ids.includes(id));
            const newTarget = [...state[targetKey]];

            return {
                ...state,
                [targetKey]: newTarget,
            };
        }

        case HIDE_CUSTOM_NOTIFICATION_POPUP:
            return {
                ...state,
                isCustomNotificationPopupVisible: false,
            };

        case SHOW_CUSTOM_NOTIFICATION_POPUP:
            return {
                ...state,
                isCustomNotificationPopupVisible: true,
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./source/reducers/notifications.js